import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import routes from 'src/routes';
import { primaryMenuConfigItem } from './primaryMenuConfigItem';

const productAlertsMenuConfig: Array<primaryMenuConfigItem> = [
  {
    label: 'Product Alerts',
    /*
      TODO: this is commented out temporarily for the upcoming release
      https://ql2.atlassian.net/browse/UI-2725
    */
    // path: routes.productAlerts,
    icon: <FontAwesomeIcon icon={['fal', 'bell-plus']} style={{ fontSize: '18px' }} />,
    children: [
      {
        label: 'Alert Results',
        path: routes.alertResults,
        icon: <FontAwesomeIcon icon={['fal', 'chart-bar']} />,
      },
      {
        label: 'Segment Config',
        path: routes.productAlerts + '/segmentConfig',
        icon: <FontAwesomeIcon icon={['far', 'sliders-h']} />,
      },
    ],
  },
];

export default productAlertsMenuConfig;
